import { createEmptySession } from './canvas-session-store';
import type { CanvasSessionRecord } from './canvas-session-types';
import { emptySiteOnboardingDraft } from './onboarding-draft';
import type { SiteListItem } from './sites-api';

/** Build a minimal complete-phase session when no local persistence exists. */
export function hydrateSessionFromSite(site: SiteListItem): CanvasSessionRecord {
  const draft = emptySiteOnboardingDraft();
  draft.businessName = site.name;
  if (site.subdomain) {
    draft.customUrls = [site.subdomain];
  }

  return {
    ...createEmptySession(),
    siteId: site.id,
    draft,
    phase: 'complete',
    publishedUrl: site.publishedUrl,
    updatedAt: Date.now(),
  };
}
